<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <EventDetail :form-data="data" slot-scope="{data}"></EventDetail>
  </l-cache>
</template>
<script>
import EventDetail from './eventDetail'
export default {
  name: 'eventDetailBox',
  components: {EventDetail},
  methods: {
    async getItem (key) {
      let pagination = {pages: 1, rowsPerPage: 10}
      let url = '/messageApi/getMsgEvent'
      let {items, amount} = await this.$store.dispatch('message/getList', {pagination, search: {key: 'id', value: this.$route.query.id}, url: url})
      if (items.length !== 0) {
        return items[0]
      }
      else {
        this.$L.alert('error', {message: '查询失败，未查到该消息事件'})
      }
    }
  }
}
</script>
